export default function SpecialLocation({setData, form}) {

    return (
        <>
            <div className={'ctrow'}>
                <div className={'col-6'}>
                    <label>City</label>
                    <input type={"text"} className={"form-control"} placeholder={"City"}
                           value={form?.city ?? ''}
                           onChange={(e) => setData({city: e.target.value})}
                    />
                </div>
                <div className={'col-3'}>
                    <label>Postcode/ZIP</label>
                    <input type={"text"} className={"form-control"} placeholder={"Postcode/ZIP"}
                           value={form?.zip ?? ''}
                           onChange={(e) => setData({zip: e.target.value})}
                    />
                </div>
            </div>
            <div style={{clear:'both'}}></div>
            <div className={'ctrow'}>
                <div className={'col-6'}>
                    <label>We recommend 2-3 locations from our partners in Switzerland, tailored to your needs and team size. Additional location searches may incur extra costs.</label>
                </div>
            </div>
        </>
    );
}